import { extractWorkflowItems, getTextVariant, hasNonemptyText, } from '#pplx/frontend/apps/ask/thread-entry-state/workflowText.js';
/**
 * Checks if a PerplexityMessage has started generating LLM tokens
 */
export function hasPerplexityMessageLLMToken(message) {
    return (!!message.blocks?.some((block) => block.intended_usage === 'ask_text') ||
        hasWorkflowAnswerText(message.blocks));
}
export function hasStreamedLLMToken(message) {
    return (!!message.blocks?.some((block) => block.markdown_block?.chunks?.length) ||
        hasWorkflowAnswerText(message.blocks));
}
function hasWorkflowAnswerText(blocks) {
    return !!blocks?.some((block) => extractWorkflowItems(block.workflow_block).some((item) => {
        const textPayload = item.payload?.text_payload;
        return getTextVariant(item) === 'answer' && hasNonemptyText(textPayload);
    }));
}
//# sourceMappingURL=llmToken.js.map